// @flow
import * as React from 'react'

/**
 * It let you make a one liner solution to keep some data in sync with
 * a a ref on every re-render of the component.
 * Insted of writing this:
 * ```
 * const aRef = React.useRef(props)
 * aRef.current = props
 * ```
 * You will just need to write this:
 * ```
 * const aRef = useLatestValueRef(props)
 * ```
 * @return {ReactRef}
 */
export default function useLatestValueRef<T>(value: T): {| current: T |} {
  const latestPropsRef = React.useRef<T>(value)
  latestPropsRef.current = value
  return latestPropsRef
}
